import { createContext, ReactNode, useState } from "react";
import { IconCheck } from "@tabler/icons-react";
import { LOADING_CIRCLE } from "../components/core/loading/LoadingCircle";

// Define the types for the context value
interface SubmitContextType {
  loading: boolean;
  setLoading: (v: boolean) => void;
  error: string | undefined;
  setError: (v: string | undefined) => void;
  buttonElem: ReactNode | null;
  setButtonElem: (v: ReactNode) => void;
  initSubmit: () => boolean;
  finishSubmit: (loading: boolean) => boolean;
}

// Create the context with default values
export const SubmitContext = createContext<SubmitContextType>({
  loading: false,
  setLoading: () => {},
  error: undefined,
  setError: () => {},
  buttonElem: null,
  setButtonElem: () => {},
  initSubmit: () => false,
  finishSubmit: () => false,
});

interface SessionProviderProps {
  children: ReactNode;
  iLoading?: boolean;
  iError?: string | undefined;
  iButtonElem?: ReactNode | null;
}

export const SubmitProvider = ({
  iLoading,
  iError,
  iButtonElem,
  children,
}: SessionProviderProps) => {
  const [loading, setLoading] = useState<boolean>(!!iLoading);
  const [error, setError] = useState<string | undefined>(iError || undefined);
  const [buttonElem, setButtonElem] = useState<ReactNode | null>(iButtonElem);

  const initSubmit = (): boolean => {
    if (loading) return false;
    setLoading(true);
    setButtonElem(LOADING_CIRCLE);
    setError(undefined);
    return true;
  };
  const finishSubmit = (loading: boolean = false) => {
    setLoading(loading);
    setButtonElem(<IconCheck />);
    return !error;
  };
  return (
    <SubmitContext.Provider
      value={{
        loading: loading,
        setLoading: (v: boolean) => setLoading(v),
        error: error,
        setError: (v: string | undefined) => setError(v),
        buttonElem: buttonElem,
        setButtonElem: (v: ReactNode | null) => setButtonElem(v),
        initSubmit: initSubmit,
        finishSubmit: finishSubmit,
      }}
    >
      {children}
    </SubmitContext.Provider>
  );
};
